const useFormError = (errors, name) => {
    const error = errors[name];
    const errorId = error && `${name}Error`;
    const errorMessage = error && error.message;
    return [errorId, errorMessage];
};
export default useFormError;
//# sourceMappingURL=index.js.map